var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-editable-element"},[_c('div',{staticClass:"overlay",on:{"click":_vm.onClick}}),_c(_vm.element,{tag:"component",attrs:{"label":_vm.value.label,"required":_vm.value.required,"field_options":_vm.value.field_options,"id":_vm.value.id,"cid":_vm.value.cid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }